import './style.scss';

export const Error404 = () => (
  <section className="py-12 d-flex flex-column align-items-center">
    <div className="container-fluid">
      <div>
        <h1 className="mb-none">Page Not Found</h1>
        <div className="error-number lh-1 mb-4">404</div>
      </div>
      <p>Oops! The link you clicked may be broken or the page may have been removed. Keep calm and don&apos;t worry though.</p>
    </div>
  </section>
);

export default Error404;
